export default __webpack_public_path__ + "static/media/user-considerations.2050d446.png";